import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import PortalVue from "portal-vue";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import apiFactory from "@/services/apiFactory";
import AppMixins from "./utilities/appMixin";
import ApiErrorHandler from "./mixins/apiErrorHandler";
import "./globalComponents";
import "@/assets/css/tailwind.css";
import disableButton from "./mixins/disableButton";
import IdleVue from "idle-vue";
import imageUpload from "./mixins/imageUpload";
import Usertype from "./mixins/Usertype";
import extractAddress from "./mixins/extractAddress";

import VueGoogleAutocomplete from "vue-google-autocomplete";
import { ApolloClient } from "apollo-client";
import { HttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import VueApollo from "vue-apollo";
import { bookingGraphQl } from "./services/graphQL/booking";
import Loader from "./components/UI/Loader";

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_AUTOCOMPLETE_API_KEY,
    libraries: "places",
  },
});

// Socket.io
import { io } from "socket.io-client";
import VueSocketIO from "vue-socket.io";

const options = {
  transports: ["websocket", "polling"],
  withCredentials: true,
};

Vue.use(
  new VueSocketIO({
    debug: true,
    connection: io(process.env.VUE_APP_GLOBAL_MESSAGING, options),
    vuex: {
      store,
      actionPrefix: "SOCKET_",
      mutationPrefix: "SOCKET_",
    },
  })
);

// ✅ Apollo (HTTP only, no subscriptions)
const httpLink = new HttpLink({
  uri: `${process.env.VUE_APP_MULEEX_MONO}/graphql`,
});

const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  connectToDevTools: true,
});

Vue.use(VueApollo);

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
    $loadingKey: "loading",
  },
});

// ApexCharts
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

// Phone Input
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
Vue.use(VueTelInput);

Vue.use(VueGoogleAutocomplete);
Vue.component(VueGoogleAutocomplete);

const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 600000,
  startAtIdle: false,
});

// Element UI
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
locale.use(lang);

import "@/assets/css/main.css";
import {
  Option,
  Select,
  DatePicker,
  TimePicker,
  Loading,
  Switch,
  Collapse,
  CollapseItem,
  Tabs,
  Tooltip,
  TabPane,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Dialog,
  Rate,
} from "element-ui";
import "./assets/css/element-variables.scss";

Vue.use(Option);
Vue.use(Select);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(Switch);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Tabs);
Vue.use(Tooltip);
Vue.use(TabPane);
Vue.use(Dropdown);
Vue.use(DropdownItem);
Vue.use(DropdownMenu);
Vue.use(Dialog);
Vue.use(Rate);
Vue.use(Loading.directive);

Vue.use(PortalVue);
Vue.use(BootstrapVue);
Vue.config.productionTip = false;

// Global Mixins
Vue.mixin(AppMixins);
Vue.mixin(ApiErrorHandler);
Vue.mixin(disableButton);
Vue.mixin(imageUpload);
Vue.mixin(Usertype);
Vue.mixin(extractAddress);
Vue.mixin({
  methods: {
    ...apiFactory,
  },
  computed: {
    $_GraphQL_Endpoint() {
      return bookingGraphQl;
    },
  },
});

new Vue({
  router,
  store,
  apolloProvider,
  data() {
    return {
      loading: true,
    };
  },
  render: function (h) {
    return this.loading ? h(Loader) : h(App);
  },
  mounted() {
    router.onReady(() => {
      this.loading = false;
    });
  },
}).$mount("#app");
